import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function AlertsPage() {
  const { t } = useTranslation();
  const [alerts, setAlerts] = useState({
    soilLow:       true,
    soilHigh:      true,
    pestHigh:      true,
    pestMedium:    false,
    weatherRain:   true,
    weatherWind:   false,
    batteryLow:    true,
    deviceOffline: true,
  });

  const toggle = (key: keyof typeof alerts) =>
    setAlerts(a => ({ ...a, [key]: !a[key] }));

  const groups = [
    {
      title: 'Soil Monitoring',
      items: [
        { key: 'soilLow'  as const, label: 'Low soil moisture',  desc: 'Alert when humidity drops below the minimum threshold.' },
        { key: 'soilHigh' as const, label: 'High soil moisture', desc: 'Alert when humidity exceeds the maximum threshold.' },
      ],
    },
    {
      title: 'Pest Monitoring',
      items: [
        { key: 'pestHigh'   as const, label: 'High pest risk',   desc: 'Alert when a zone reaches high infestation risk.' },
        { key: 'pestMedium' as const, label: 'Medium pest risk', desc: 'Alert when a zone reaches medium infestation risk.' },
      ],
    },
    {
      title: 'Weather',
      items: [
        { key: 'weatherRain' as const, label: 'Heavy rain forecast', desc: 'Alert when rain probability exceeds 60%.' },
        { key: 'weatherWind' as const, label: 'High wind advisory',  desc: 'Alert when wind speed exceeds 50 km/h.' },
      ],
    },
    {
      title: 'Device Health',
      items: [
        { key: 'batteryLow'    as const, label: 'Low battery',    desc: 'Alert when a sensor battery drops below 20%.' },
        { key: 'deviceOffline' as const, label: 'Device offline', desc: 'Alert when a sensor stops reporting for more than 2 hours.' },
      ],
    },
  ];

  return (
    <div className="page">
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4 }}>{t('alertsPage.title')}</h1>
        <p style={{ fontSize: 13, color: 'var(--gray)' }}>{t('alertsPage.subtitle')}</p>
      </div>

      <div style={{ maxWidth: 600, display: 'flex', flexDirection: 'column', gap: 20 }}>
        {groups.map(group => (
          <div key={group.title}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--gray)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 10 }}>
              {group.title}
            </div>
            <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 12, padding: '4px 18px' }}>
              {group.items.map(item => (
                <div
                  key={item.key}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '13px 0', borderBottom: '1px solid var(--border)' }}
                >
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>{item.label}</div>
                    <div style={{ fontSize: 11, color: 'var(--gray)', marginTop: 2 }}>{item.desc}</div>
                  </div>
                  <Toggle value={alerts[item.key]} onChange={() => toggle(item.key)} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Toggle({ value, onChange }: { value: boolean; onChange: () => void }) {
  return (
    <div
      onClick={onChange}
      style={{
        width: 42, height: 24, borderRadius: 12,
        background: value ? 'var(--green)' : 'var(--border)',
        cursor: 'pointer', position: 'relative',
        transition: 'background 0.2s', flexShrink: 0, marginLeft: 16,
      }}
    >
      <div style={{
        position: 'absolute', top: 3, left: value ? 21 : 3,
        width: 18, height: 18, borderRadius: '50%', background: '#fff',
        transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
      }} />
    </div>
  );
}
